<template>
  <div class="service-contain">
    <div class="slogin">服务商五维价值赋能</div>
    <div class="tab-container">
      <div
        class="tab-slider"
        :style="{
          left: sliderLeft + 'px',
          width: sliderWidth + 'px',
        }"
      ></div>

      <!-- Tab 选项卡列表 -->
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="tab-item"
        @mouseenter="currentIndex = index"
        :class="{ 'tab-item-active': currentIndex === index }"
      >
        {{ item }}
      </div>
    </div>

    <div class="tabDesList">
      <div
        class="tabDesList-slider"
        :style="{
          transform: `translateX(-${currentIndex * 100}%)`,
          transition: 'transform 0.8s ease',
        }"
      >
        <div
          v-for="(item, tabDesIndex) in tabDesList"
          :key="tabDesIndex"
          class="tabDesList-item"
          :class="{ 'tabDesList-item-sepcial': tabDesIndex == 1 }"
        >
          <div class="tabDesList-item-title">{{ item.title }}</div>
          <div
            class="tabDesList-item-midde flex-around"
            :style="{ backgroundImage: `url(${item.bgimg})` }"
          >
            <div class="midde-flex-box">
              <div class="title flex-start">
                <img :src="item.titlefirstimg" alt="" /> {{ item.titlefirst }}
              </div>
              <div class="des">{{ item.desFirst }}</div>
            </div>
            <div class="midde-flex-box">
              <div class="title flex-start">
                <img :src="item.titleSecondimg" alt="" />{{ item.titleSecond }}
              </div>
              <div class="des">{{ item.desSecond }}</div>
            </div>
            <div class="midde-flex-box">
              <div class="title flex-start">
                <img :src="item.teitleThredimg" alt="" />{{ item.teitleThred }}
              </div>
              <div class="des">{{ item.desThred }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabList: ["数据支持", "协助管理", "全国供应链", "一码连通", "灵活支付"],
      currentIndex: 0,
      sliderLeft: 0,
      sliderWidth: 160,

      tabDesList: [
        {
          title: "平台全天在线，数据驱动决策",
          bgimg: "https://ztc-obs.zgztc.cn/2025/12/25/97fdbf5e-1f56-44d6-8c98-f5dead0671fe.png",
          titlefirst: "全天在线支持",
          titlefirstimg: require("@/assets/imgs/service1.png"),
          titleSecond: "实时数据洞察",
          titleSecondimg: require("@/assets/imgs/service2.png"),
          teitleThred: "精细化运营策略",
          teitleThredimg: require("@/assets/imgs/service3.png"),
          desFirst:
            "纵购直通车为服务商提供24小时在线平台支持，终端门店可随时查价下单",
          desSecond: "依托平台数据分析看板，服务商实时洞察区域动销与品类趋势",
          desThred: "精准制定商品策略与营销规划，实现数据驱动的精细化运营。",
        },
        {
          title: "系统多维赋能，运营精准提效",
          bgimg: "https://ztc-obs.zgztc.cn/2025/12/25/66b41aee-2e18-4e8a-94f3-d80c31050247.png",
          titlefirst: "客户管理工具",
          titlefirstimg: require("@/assets/imgs/service4.png"),
          titleSecond: "优化订单流程",
          titleSecondimg: require("@/assets/imgs/service5.png"),
          teitleThred: "降本效能提升",
          teitleThredimg: require("@/assets/imgs/service6.png"),
          desFirst:
            "平台提供客户管理工具（纵购星链CRM）及进销存系统（渠道云），为服务商提供强有力的支持",
          desSecond:
            "系统帮助服务商高效整合客户资源，优化订单处理流程，从而提升运营效率",
          desThred:
            "通过减少人力和时间成本，实现运营降本，同时有效提升整体业务效能与竞争力",
        },
        {
          title: "品类协同支持，商品便捷上架",
          bgimg: "https://ztc-obs.zgztc.cn/2025/12/25/e71fbcc5-c0a6-499c-a49a-5f2a3ad69bee.png",
          titlefirst: "便捷上架商品",
          titlefirstimg: require("@/assets/imgs/service7.png"),
          titleSecond: "供应链协同支持",
          titleSecondimg: require("@/assets/imgs/service8.png"),
          teitleThred: "提升市场竞争力",
          teitleThredimg: require("@/assets/imgs/service9.png"),
          desFirst: "服务商可轻松上架联营商品，快速拓展本地经营品类",
          desSecond: "借助全国供应链网络，服务商可实现商品资源整合与库存联动",
          desThred: "优化商品整合和库存管理，增强区域市场的竞争与响应能力",
        },
        {
          title: "渠道一码连通，服务稳固客情",
          bgimg:"https://ztc-obs.zgztc.cn/2025/12/25/e78ce8e2-222e-41d2-984a-98753258ff23.png",
          titlefirst: "建立服务关系",
          titlefirstimg: require("@/assets/imgs/service10.png"),
          titleSecond: "一码覆盖全城",
          titleSecondimg: require("@/assets/imgs/service11.png"),
          teitleThred: "提升客户忠诚度",
          teitleThredimg: require("@/assets/imgs/service12.png"),
          desFirst: "终端门店通过专属渠道码快速注册，建立长期服务关系",
          desSecond: "一码覆盖全城，助力服务商建立稳固的客户网络",
          desThred: "通过持续优质的本地化服务，有效提升客户忠诚度与复购率",
        },
        {
          title: "支付灵活高效，资金快速周转",
          bgimg:"https://ztc-obs.zgztc.cn/2025/12/25/721dc404-6179-463e-8fcf-c18199129e8a.png",
          titlefirst: "灵活支付方式",
          titlefirstimg: require("@/assets/imgs/service13.png"),
          titleSecond: "构建安全交易闭环",
          titleSecondimg: require("@/assets/imgs/service14.png"),
          teitleThred: "快速资金周转",
          teitleThredimg: require("@/assets/imgs/service15.png"),
          desFirst: "平台提供多种灵活支付方式，打通“下单-支付-结算”全流程",
          desSecond: "形成高效、安全的交易闭环，助力服务商优化资金使用效率",
          desThred: "加快周转速度，显著提升终端服务的客户满意度",
        },
      ],
    };
  },
  watch: {
    currentIndex(newVal) {
      const gap =
        (880 - this.tabList.length * this.sliderWidth) /
        (this.tabList.length * 2);
      this.sliderLeft = newVal * (this.sliderWidth + 2 * gap) + gap;
    },
  },
  mounted() {
    this.calcSliderPosition(this.currentIndex);
  },
  methods: {
    calcSliderPosition(index) {
      const gap =
        (880 - this.tabList.length * this.sliderWidth) /
        (this.tabList.length * 2);
      this.sliderLeft = index * (this.sliderWidth + 2 * gap) + gap;
    },
  },
};
</script>

<style lang="less" scoped>
.service-contain {
  width: 1170px;
  margin: auto;
  margin-top: 170px;

  .slogin {
    height: 48px;
    font-family: MicrosoftYaHei, MicrosoftYaHei;
    font-weight: bold;
    font-size: 48px;
    color: #3e3e3e;
    line-height: 48px;
    text-align: center;
  }

  .tab-container {
    position: relative;
    margin: 60px auto;
    display: flex;
    width: 880px;
    height: 68px;
    background: rgba(0, 0, 0, 0.05);
    border-radius: 50px;
    overflow: hidden;

    // 滑动滑块样式
    .tab-slider {
      position: absolute;
      top: 10px;
      height: 48px;
      border-radius: 42px;
      background: #3e3e3e;
      transition: left 0.8s ease;
      z-index: 1;
      cursor: pointer;
    }

    .tab-item {
      position: relative;
      z-index: 2;
      margin: auto;
      width: 160px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      border-radius: 42px;
      cursor: pointer;
      font-family: MicrosoftYaHei;
      font-size: 20px;
      color: #666;
    }

    .tab-item-active {
      color: #ffffff !important;
    }
  }

  .tabDesList {
    overflow: hidden;
    position: relative;
    width: 100%;

    // 新增：滑动容器
    .tabDesList-slider {
      display: flex;
      width: 100%;
      height: 100%;
    }

    .tabDesList-item {
      flex: 0 0 100%;
      width: 100%;
      box-sizing: border-box;

      .tabDesList-item-title {
        height: 47px;
        font-family: MicrosoftYaHei;
        font-size: 36px;
        color: #000000;
        line-height: 47px;
        text-align: center;
        margin-bottom: 30px;
      }

      .tabDesList-item-midde {
        width: 1170px;
        height: 500px;
        box-sizing: border-box;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;

        .midde-flex-box {
          width: 270px;
          text-align: center;
          // border:1px solid;

          .title {
            height: 26px;
            font-family: MicrosoftYaHei;
            font-size: 20px;
            color: #000000;
            line-height: 26px;
            margin: 30px auto 20px auto;
            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 40px;
              height: 40px;
              margin-top: 5px;
            }
          }
          .des {
            font-family: MicrosoftYaHei;
            font-size: 16px;
            color: #585f65;
            line-height: 24px;
            text-align: left;
            // border: 1px solid;
          }
        }
      }

      &.tabDesList-item-sepcial {
        .midde-flex-box {
          width: 380px;
        }
      }
    }
  }
}
</style>
